/**
 * Listas centralizadas de relaciones de parentesco.
 *
 * - EMERGENCY_CONTACT_RELATIONSHIPS: para el campo `emergencyContact.relationship`
 *   (contacto de emergencia de una Persona). Incluye Esposo/a que faltaba en varios sitios.
 * - GUARDIAN_RELATIONSHIPS: para `guardianRelation` (relación acudiente ↔ menor a cargo).
 */

export const EMERGENCY_CONTACT_RELATIONSHIPS = [
  "Padre",
  "Madre",
  "Esposo/a",
  "Hermano/a",
  "Abuelo/a",
  "Tío/a",
  "Otro familiar",
  "Tutor Legal",
  "Acudiente",
  "Otro",
] as const;

export type EmergencyContactRelationship =
  (typeof EMERGENCY_CONTACT_RELATIONSHIPS)[number];

export const GUARDIAN_RELATIONSHIPS = [
  { value: "madre", label: "Madre" },
  { value: "padre", label: "Padre" },
  { value: "tutor", label: "Tutor" },
  { value: "abuelo", label: "Abuelo" },
  { value: "abuela", label: "Abuela" },
  { value: "hermano", label: "Hermano" },
  { value: "hermana", label: "Hermana" },
  { value: "otro", label: "Otro" },
] as const;
